<script lang="ts">
export default {
    name: 'BasePopConfirm',
};
</script>

<script setup lang="ts">
import { Placement } from '@/components/base-components/types/placement';

withDefaults(defineProps<{
    title?: string;
    message?: string;
    confirmText?: string;
    confirmType?: 'default' | 'primary' | 'danger';
    cancelText?: string;
    cancelType?: 'default' | 'primary' | 'danger';
    trigger?: 'hover' | 'click';
    align?: 'edge' | 'center';
    placement?: Placement;
}>(), {
    confirmText: 'Yes',
    confirmType: 'danger',
    cancelText:  'No',
    cancelType:  'default',
    align:       'center',
});

const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'cancel'): void;
}>();

function onConfirm() {
    emit('confirm');
}

function onCancel() {
    emit('cancel');
}
</script>

<template>
    <base-popover
        :trigger="trigger"
        :placement="placement"
    >
        <template #reference>
            <slot name="reference" />
        </template>

        <template #content>
            <div class="grid gap-2 p-3 text-sm">
                <slot name="content">
                    <div v-if="title || message" class="grid gap-1 px-2 py-1">
                        <div
                            v-if="title"
                            v-html="title"
                            class="font-semibold"
                            :class="{
                                'text-center': align === 'center'
                            }"
                        />

                        <div
                            v-if="message"
                            v-html="message"
                            class="max-w-xs"
                            :class="{
                                'text-center': align === 'center'
                            }"
                        />
                    </div>
                </slot>

                <slot name="actions" :confirm="onConfirm" :cancel="onCancel">
                    <div
                        class="flex items-center gap-2"
                        :class="{
                            'justify-end': align === 'edge',
                            'justify-center': align === 'center',
                        }"
                    >
                        <base-button
                            size="small"
                            :type="confirmType"
                            :label="confirmText"
                            :text-transform="false"
                            @click="onConfirm"
                        />
                        <base-button
                            size="small"
                            text
                            :type="cancelType"
                            :label="cancelText"
                            :text-transform="false"
                            @click="onCancel"
                        />
                    </div>
                </slot>
            </div>
        </template>
    </base-popover>
</template>
